import React, { lazy, Suspense } from 'react';
import { MapSkeleton } from '@/components/common/SkeletonLoader';
import type { WardInfo } from '@/types/ward';

// Lazy load the MapView component
const MapView = lazy(() => import('./MapView').then(module => ({
  default: module.MapView
})));

interface LazyMapViewProps {
  onWardSelect?: (ward: WardInfo) => void;
  selectedWardId?: number;
  className?: string;
}

/**
 * Lazy-loaded wrapper for MapView component
 * This helps reduce initial bundle size by loading ArcGIS dependencies on demand
 */
export const LazyMapView: React.FC<LazyMapViewProps> = (props) => {
  return (
    <Suspense fallback={<MapSkeleton />}>
      <MapView {...props} />
    </Suspense>
  );
};